import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../../axiosBaseQuery";
import { MAINTENANCE_ENDPOINTS } from "../../../../api/constants";

/**
 * RTK Query API окон планового обслуживания EyeHub (Ц13).
 *
 * GET    maintenance-windows/       — список (RBAC на бэкенде: провайдер видит все org,
 *        организация — только свои). Ответ — UnifiedOffsetPagination
 *        ({results, count, pageIndex, pageCount, ...}).
 * POST   maintenance-windows/       — создание (IsHubStaff). Поля:
 *        org (id), site (id|null), starts_at, ends_at, note.
 * PATCH  maintenance-windows/{id}/  — изменение интервала/площадки/примечания (IsHubStaff).
 * DELETE maintenance-windows/{id}/  — отмена окна (IsHubStaff).
 *
 * До появления PATCH/DELETE запланированное окно нельзя было ни исправить, ни
 * отменить — операционный риск для инструмента, которым анонсируют простой клиникам.
 */
export const maintenanceApi = createApi({
  reducerPath: "maintenanceApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["MaintenanceWindow"],
  endpoints: (builder) => ({
    getMaintenanceWindows: builder.query({
      query: ({ limit = 50, offset = 0, org, site } = {}) => ({
        url: MAINTENANCE_ENDPOINTS.LIST,
        method: "GET",
        params: {
          limit,
          offset,
          ...(org ? { org } : {}),
          ...(site ? { site } : {}),
        },
      }),
      providesTags: [{ type: "MaintenanceWindow", id: "LIST" }],
    }),

    createMaintenanceWindow: builder.mutation({
      query: (data) => ({ url: MAINTENANCE_ENDPOINTS.LIST, method: "POST", data }),
      invalidatesTags: [{ type: "MaintenanceWindow", id: "LIST" }],
    }),

    /** Частичное обновление окна: `{id, ...patch}` → `PATCH maintenance-windows/{id}/`. */
    updateMaintenanceWindow: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: MAINTENANCE_ENDPOINTS.DETAIL(id),
        method: "PATCH",
        data: patch,
      }),
      invalidatesTags: [{ type: "MaintenanceWindow", id: "LIST" }],
    }),

    /** Отмена (удаление) окна обслуживания. */
    deleteMaintenanceWindow: builder.mutation({
      query: (id) => ({ url: MAINTENANCE_ENDPOINTS.DETAIL(id), method: "DELETE" }),
      invalidatesTags: [{ type: "MaintenanceWindow", id: "LIST" }],
    }),
  }),
});

export const {
  useGetMaintenanceWindowsQuery,
  useCreateMaintenanceWindowMutation,
  useUpdateMaintenanceWindowMutation,
  useDeleteMaintenanceWindowMutation,
} = maintenanceApi;

export default maintenanceApi;
